var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRemoveBackground = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 0.843,
  d: "M5.974 3.631a2.81 2.81 0 0 1 0 3.976M4.65 4.957a.937.937 0 0 1 0 1.325M9.558 6.86v1.124c0 .87-.705 1.575-1.574 1.575H6.859m2.7-5.173V3.26c0-.87-.706-1.574-1.575-1.574H6.859M4.385 9.559H3.261c-.87 0-1.574-.705-1.574-1.575V6.86m0-2.474V3.26c0-.87.704-1.574 1.574-1.574h1.124"
})));
export default SvgRemoveBackground;